// extracted by mini-css-extract-plugin
export default {"root":"xA3_U","type":"ML8hJ","captcha":"ZUeN6","closed":"dtxq9","rules":"tFpGX","agreement":"udrTa","submit":"bKDUL"};